/* eslint-disable @typescript-eslint/no-explicit-any  */
import type React from 'react';
import type {
  EventObject,
  Interpreter,
  MachineConfig as XMachineConfig,
  MachineOptions as XMachineOptions,
  State as XState,
  StateNodeConfig as XStateNodeConfig
} from 'xstate';

import type { Fork, Invoke } from '@swf/components/StarsWizard/Flow';

import type { ErrorCollection } from './Response';

export enum Event {
  NEXT = 'NEXT',
  PREVIOUS = 'PREVIOUS',
  JUMP = 'JUMP'
}

export enum Action {
  ValuesAssign = 'valuesAssign',
  DataAssign = 'dataAssign',
  ErrorAssign = 'errorAssign',
  ErrorReset = 'errorReset',
  GoNext = 'goNext',
  GoPrevious = 'goPrevious',
  GoJump = 'goJump'
}

export enum ForkState {
  Eventless = 'fork-eventless',
  OnPrevious = 'fork-on-previous'
}

export interface WizardContext<D = any, V = any> {
  data: D;
  values: V;
  error: ErrorCollection | null;
}

export type State = XState<WizardContext>;

export type StateNodeConfig = XStateNodeConfig<WizardContext, any, EventObject>;

export type Wizard = Interpreter<WizardContext>;

export type WizardGuard = (...args: [WizardContext]) => boolean;

export interface StateDefinition extends StateNodeConfig {
  name: string;
}

export type FlowItem = React.ComponentType | Invoke | Fork | StateDefinition;

export type FlowConfig = FlowItem[];

export type FlowItemOrArray = FlowItem | FlowItem[];

export interface FlowProp {
  flow: FlowConfig;
}

export interface WizardProp {
  wizard: Wizard;
}

export interface NameProp {
  name: string;
}

export interface StateProp {
  state: State;
}

export type NameFlowProps = NameProp & FlowProp;

export type MachineOptions = Partial<XMachineOptions<WizardContext, EventObject>>;

export type MachineConfig = XMachineConfig<WizardContext, any, EventObject>;

export interface NavigationDirections {
  next?: boolean;
  previous?: boolean;
}

export interface TransitionProps {
  in?: boolean;
}

export interface GroupProps extends NameFlowProps, MachineOptions {
  transition?: React.ComponentType<TransitionProps>;
}
